export default "/assets/weigh-ins-gain-placeholder.png";